// Shared CRM constants and formatters
export const STAGES = [
  { id: 'New Lead', color: '#3B82F6', bg: '#EFF6FF' },
  { id: 'Contacted', color: '#8B5CF6', bg: '#F5F3FF' },
  { id: 'Qualified', color: '#F59E0B', bg: '#FFFBEB' },
  { id: 'Proposal Sent', color: '#06B6D4', bg: '#ECFEFF' },
  { id: 'Negotiating', color: '#EC4899', bg: '#FDF2F8' },
  { id: 'Closed Won', color: '#10B981', bg: '#ECFDF5' },
  { id: 'Closed Lost', color: '#6B7280', bg: '#F3F4F6' },
];

export const getStageConfig = (stageId) => STAGES.find(s => s.id === stageId) || STAGES[0];

export const formatValue = (value) => {
  if (!value && value !== 0) return '$0';
  return `$${parseFloat(value).toLocaleString()}`;
};

export const formatDate = (dateStr, withYear = false) => {
  if (!dateStr) return '—';
  const opts = withYear
    ? { month: 'short', day: 'numeric', year: 'numeric' }
    : { month: 'short', day: 'numeric' };
  return new Date(dateStr).toLocaleDateString('en-US', opts);
};

export const formatTime = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};
